import { styled } from '@mui/material';
import { LayoutContext } from '../../context';

const PREFIX = 'Minimal';

export const classes = {
  root: `${PREFIX}-root`,
  main: `${PREFIX}-main`,
  header: `${PREFIX}-header`,
};

export const StyledLayoutContextProvider = styled(LayoutContext.Provider)(({ theme }) => ({
  [`& .${classes.root}`]: {
    backgroundColor: 'white',
    height: '100%',
  },

  [`& .${classes.main}`]: {
    padding: theme.spacing(4),
  },

  [`& .${classes.header}`]: {
    padding: theme.spacing(4),
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
}));